import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import Navigation from '../../../Layouts/Navigation/Navigation';
import { BASE_URL } from '../../../utils/constants';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';

function TowerPackages() {
  const { id_torre } = useParams();
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/getPackagesByTower/${id_torre}`);
        setPackages(response.data);
        setFilteredPackages(response.data);
      } catch (error) {
        console.error('Error fetching packages:', error);
      }
    };

    fetchPackages();
  }, [id_torre]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredPackages(
      packages.filter((pkg) =>
        `${pkg.nombre} ${pkg.apellido}`.toLowerCase().includes(value) ||
        pkg.num_apartamento.toString().includes(value) ||
        pkg.estado.toLowerCase().includes(value)
      )
    );
  };

  const handleViewDetails = (pkg) => {
    setSelectedPackage(pkg);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedPackage(null);
  };

  return (
    <>
      <Navigation />
      <Container>
        <Box sx={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center' }}>
            Paquetes de la Torre {id_torre}
          </Typography>
          <Button variant="contained" color="secondary" onClick={() => navigate(-1)}>
            Volver
          </Button>
        </Box>
        <Box sx={{ marginBottom: '20px' }}>
          <TextField
            label="Buscar"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Buscar por nombre, apartamento o estado"
          />
        </Box>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Teléfono</TableCell>
                <TableCell>Apartamento</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Fecha de Recibido</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPackages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pkg) => (
                <TableRow key={pkg.id_paquete}>
                  <TableCell>{pkg.nombre} {pkg.apellido}</TableCell>
                  <TableCell>{pkg.telefono}</TableCell>
                  <TableCell>{pkg.num_apartamento}</TableCell>
                  <TableCell>{pkg.estado}</TableCell>
                  <TableCell>{formatDate(pkg.fecha_recibido)}</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="primary" onClick={() => handleViewDetails(pkg)}>
                      Ver Detalles
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredPackages.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </Container>

      {/* Diálogo para mostrar detalles del paquete */}
      <Dialog
        fullScreen={false}
        fullWidth
        maxWidth="md"
        sx={{ width: { xs: '90%', md: '50%' }, mx: 'auto' }}
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          <Typography>
            Estado del paquete: {selectedPackage ? selectedPackage.estado : 'Cargando...'}
          </Typography>
          <Typography>
            {selectedPackage && selectedPackage.estado === 'Entregado' && (
              <>Fecha de entrega: {formatDate(selectedPackage.fecha_entrega)}</>
            )}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {selectedPackage ? (
            <>
              <TableContainer elevation={3} sx={{ p: 2, border: '1px solid #ccc' }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', textAlign: 'center' }}>Información del paquete:</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>{selectedPackage.nombre} {selectedPackage.apellido}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Fecha de Recibido</TableCell>
                      <TableCell>{formatDate(selectedPackage.fecha_recibido)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Estado</TableCell>
                      <TableCell>{selectedPackage.estado}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Observaciones</TableCell>
                      <TableCell>{selectedPackage.observacion}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Remitente</TableCell>
                      <TableCell>{selectedPackage.remitente}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Tipo de Paquete</TableCell>
                      <TableCell>{selectedPackage.tipo_paquete}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Cantidad</TableCell>
                      <TableCell>{selectedPackage.cantidad}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer elevation={3} sx={{ p: 2, border: '1px solid #ccc' }}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', textAlign: 'center' }}>Residente</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>{selectedPackage.nombre} {selectedPackage.apellido}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Teléfono</TableCell>
                      <TableCell>
                        {selectedPackage.telefono}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Correo</TableCell>
                      <TableCell>{selectedPackage.email}</TableCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                    <TableRow>
                      <TableCell>Torre</TableCell>
                      <TableCell>{selectedPackage.torre_nombre}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Número de Apartamento</TableCell>
                      <TableCell>{selectedPackage.num_apartamento}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Piso</TableCell>
                      <TableCell>{selectedPackage.piso}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography>Cargando...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TowerPackages;
